module.exports = __webpack_public_path__ + "static/media/logo-full-color-medium.07302cc3.png";